export default "__VITE_ASSET__Dt026fmW__"